import React, { Component } from 'react';
import View from '../../hoc/View';
import { COFFEE } from '../../utils/constants';
import Loader from '../../components/UI/Loader';
import { func, string } from 'prop-types';

export default class ItemsList extends Component {
  static propTypes = {
    searchText: string,
    pageType: string,
    onItemSelected: func,
    onSearch: func,
  }

  static defaultProps = {
    searchText: '',
    pageType: '',
    onItemSelected: () => { },
    onSearch: () => { },
  }

  state = {
    items: null,
    searchItem: '',
    filter: 'All',
    _isMounted: false,
  }

  componentDidMount() {
    this._isMounted = true

    const { getData } = this.props

    getData()
      .then(items => {
        if (this._isMounted) {
          this.setState({ items })
        }
      })
      .catch(() => console.log('312123123'))
  }

  componentWillUnmount() {
    this._isMounted = false
  }

  onSearchItems = () => {
    const { searchText } = this.props
    const { items } = this.state

    if (!searchText || !searchText.trim().length) {
      return items
    }
    return items.filter(({ name }) => name.toLowerCase().includes(searchText.trim().toLowerCase()))
  }

  onFilterSelect = filter => {
    this.setState({ filter })
  }

  filterItems(items, filter) {
    if (filter === 'All') {
      return items
    } else {
      return items.filter(({ country }) => country === filter)
    }
  }

  render() {
    const { items, filter } = this.state
    const { pageType, onItemSelected, onSearch } = this.props

    if (!items) {
      return <Loader />
    }

    if (!items.length) {
      return <h1 style={{ textAlign: 'center', padding: '80px 0' }}>An error occured on loading products</h1>
    }

    const visibleItems = this.filterItems(this.onSearchItems(), filter)

    return (
      <View
        items={pageType === COFFEE ? visibleItems : items}
        pageType={pageType}
        onSearch={onSearch}
        onFilterSelect={this.onFilterSelect}
        onItemSelected={onItemSelected}
      />
    )
  }
}
